/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { renderFields } from '@highnoteplatform/card-viewer'
import { Images } from '@/theme/Images'

export const CardViewerComponent = ({ clientToken, paymentCardId, cardHolderName }) => {
  const isRenderedRef = useRef(false)

  // Default styles for the iframe content
  const defaultStyles = {
    cardNumber: {
      fontSize: '16px',
      color: '#FFFFFF',
      fontFamily: 'monospace',
      letterSpacing: '1px',
    },
    cvv: {
      fontSize: '16px',
      color: '#FFFFFF',
      fontFamily: 'monospace',
    },
    expirationDate: {
      fontSize: '16px',
      color: '#FFFFFF',
      fontFamily: 'monospace',
    },
  }

  useEffect(() => {
    console.log('CardViewerComponent mounted')
    const initializeCardViewer = async () => {
      // Check if the card viewer has already been rendered
      if (isRenderedRef.current) return
      isRenderedRef.current = true

      try {
        await renderFields({
          clientToken,
          paymentCardId,
          enableClipboard: false,
          environment: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'production' ? 'live' : 'test',
          maskedOnLoad: false,
          onError: error => {
            console.error('Error rendering card viewer:', error)
          },
          onReady: () => {
            console.log('Card viewer is ready')
            // Remove the hidden class from the card number, expiration date, and CVV fields
            // This makes the elements change position and render correctly
            document.querySelector('#cardNumber').classList.remove('hidden')
            document.querySelector('#expirationDate').classList.remove('hidden')
            document.querySelector('#cvv').classList.remove('hidden')
          },
          elements: {
            cardNumber: {
              selector: '#cardNumber',
              styles: defaultStyles.cardNumber,
            },
            cvv: {
              selector: '#cvv',
              styles: defaultStyles.cvv,
            },
            expirationDate: {
              selector: '#expirationDate',
              styles: defaultStyles.expirationDate,
            },
          },
        })
      } catch (err) {
        console.error('Error initializing card viewer:', err)
      }
    }

    initializeCardViewer()
  }, [])

  return (
    <div className={`w-full h-auto relative inline-block`} data-testid="credit-card-mockup-container">
      <img src={Images.creditCardBackground} alt="credit card mockup" />

      <div className="absolute top-[10%] left-0 w-full h-[20%] bg-black" />

      {/* Card Number */}
      <div id="cardNumber" className="absolute top-[40%] left-[27%] hidden" />

      <div className="absolute top-[58%] left-[28%] flex flex-row items-center gap-10">
        {/* Exp. Date */}
        <div className="flex flex-col items-center">
          <p className="text-white text-nowrap font-manrope text-[7.75px] md:text-xs font-semibold leading-[10.59px] md:leading-[16.39px] tracking-[0.05em]">
            Exp. Date
          </p>
          <div id="expirationDate" className="absolute top-[100%] -left-1 hidden" />
        </div>

        {/* CVV */}
        <div className="flex flex-col items-center">
          <p className="text-white text-nowrap font-manrope text-[7.75px] md:text-xs font-semibold leading-[10.59px] md:leading-[16.39px] tracking-[0.05em]">
            Security Code
          </p>
          <div id="cvv" className="absolute top-[100%] left-[50%] hidden" />
        </div>
      </div>

      {/* Cardholder Name */}
      <div className="absolute top-[70%] left-[28%] pt-3 md:pt-4 text-white font-manrope text-xs md:text-[16.41px] font-semibold leading-[14.47px] md:leading-[22.41px] tracking-[0.05em] text-left">
        {cardHolderName}
      </div>
    </div>
  )
}

CardViewerComponent.propTypes = {
  clientToken: PropTypes.string.isRequired,
  paymentCardId: PropTypes.string.isRequired,
  cardHolderName: PropTypes.string,
}
